export default {
    state: {
        client_name: '',
        title: '',
        date: '',
        account_manager: '',
        position: '',
        mobile: '',
        telephone: '',
        email: '',
        dublin_office: 'Unit 18 Western Parkway Business Centre, Ballymount Road, Ballymount, Dublin 12. D12 V8XT',
        nenagh_office: 'Unit 1 Springfort Business Park, Limerick Road, Nenagh, Co. Tipperary. E45 V524',
        quotes: [],
    }    
};


// WEBPACK FOOTER //
// ./src/store/QuoteStash.js